/* src/app/common/components/menu-selection/menu-selection.component.scss */
.template-selection-link,
.template-selection-link.ion-activatable:hover {
  --color-hover: var(--ion-color-primary);
  color: var(--ion-color-primary);
}
.template-selection-link ion-icon {
  margin-right: 12px;
}
.template-selection-link ion-label {
  max-width: unset;
  overflow: visible;
}
.template-selection-link .indicator {
  position: absolute;
  right: 9px;
  top: 12px;
  z-index: 2;
  background-color: var(--ion-color-success);
  width: 12px;
  height: 12px;
  border-radius: 50%;
}
.selection-name {
  flex-grow: 0;
  flex-basis: unset;
}
.menu-list-content {
  --padding-start: 0;
  --padding-end: 0;
  --inner-padding-end: 0;
}
.menu-list-content ion-item.menu-item {
  --padding-start: 12px;
  --padding-end: 12px;
  --min-height: 72px;
  border-bottom: 1px solid var(--ion-color-light);
  transition: background 0.2s ease-in-out;
}
.menu-list-content ion-item.menu-item:nth-child(odd) {
  background: #fff;
}
.menu-list-content ion-item.menu-item:nth-child(even) {
  background: #f4f4f4;
}
.menu-list-content ion-item.menu-item:hover {
  background: #e6e6e6;
}
.menu-list-content ion-item.menu-item .menu-thumbnail {
  width: 56px;
  height: 56px;
  border-radius: 8px;
  overflow: hidden;
}
.menu-list-content ion-item.menu-item .menu-thumbnail img {
  object-fit: cover;
  width: 100%;
  height: 100%;
}
.menu-list-content ion-item.menu-item .menu-label {
  padding-left: 10px;
}
.menu-list-content ion-item.menu-item .menu-label .menu-title {
  font-size: 1rem;
  font-weight: 600;
  margin: 0;
}
.menu-list-content ion-item.menu-item .menu-label .tags {
  font-size: 0.85rem;
  color: var(--ion-color-medium);
  display: flex;
  align-items: center;
  gap: 6px;
}
.menu-list-content ion-item.menu-item .menu-label .tags .tag-icon {
  font-size: 1rem;
  color: var(--ion-color-primary);
}
/*# sourceMappingURL=menu-selection.component.css.map */
